module.exports = __webpack_public_path__ + "static/media/YB5F13_4.76317b01.jpg";